export default "__VITE_ASSET__BS90YvOa__"